'use client';

import { AuthProvider, useAuth } from 'ui/providers/auth-provider';

import { Box } from 'ui/components/box';
import { Button } from 'ui/components/button';
import NextLink from 'next/link';

export function PartnerLink() {
  return (
    <AuthProvider>
      <PartnerLinkConnected />
    </AuthProvider>
  );
}

function PartnerLinkConnected() {
  const { user } = useAuth();

  return (
    <Box css={{ paddingY: 6 }}>
      {user ? (
        <Box css={{ gap: 6 }} layout='flexRow'>
          <NextLink href='/user/partner/affiliate'>
            <Button variant='filled'>Affiliate Sign Up</Button>
          </NextLink>

          <NextLink href='/user/partner/provider'>
            <Button variant='filled'>Provider Sign Up</Button>
          </NextLink>
        </Box>
      ) : (
        <NextLink href='/user/login?redirectTo=/content/partner'>
          <Button variant='filled'>Login to continue</Button>
        </NextLink>
      )}
    </Box>
  );
}
